// extracted by mini-css-extract-plugin
module.exports = {"container":"Intro_container__Tk1JN"};